// extracted by mini-css-extract-plugin
export var postGrid = "N_bn";